import styled, { css } from 'styled-components';

import { FaChevronRight } from 'react-icons/fa';
import { Color } from '../../../shared/constants/Colors';
import {
  FontSize,
  FontType,
  FontWeight,
} from '../../../shared/constants/Fonts';
import { MediaQuery } from '../../../shared/constants/Styles';
import { BreadcrumbAppearance } from './Breadcrumb';

export const ThemeBreadcrumb = css`
  color: ${Color.CLOUD_BURST};
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.S};
  letter-spacing: 0;
  line-height: 19px;
  text-decoration: none;
  outline: none;
  padding: 0 5px;
  box-sizing: border-box;
  border-radius: 5px;
  border: 2px solid transparent;

  ${MediaQuery.S_AND_DOWN} {
    padding: ${({ isHomeLink }) => (isHomeLink ? '0 5px 5px 0' : '0 5px')};
    border: none;
  }
`;

export const PageName = styled.p`
  ${ThemeBreadcrumb};
  font-weight: ${FontWeight.BLACK};
  display: inline;

  color: ${({ appearance }) =>
    appearance === BreadcrumbAppearance.MINIMAL && Color.WHITE};
`;

export const PageLink = styled.a`
  ${ThemeBreadcrumb};
  font-weight: ${FontWeight.REGULAR};

  color: ${({ appearance }) =>
    appearance === BreadcrumbAppearance.MINIMAL && Color.WHITE};

  &:hover {
    background-color: ${Color.WHISPER};
    color: ${({ appearance }) =>
      appearance === BreadcrumbAppearance.MINIMAL && Color.CLOUD_BURST};
  }

  &:focus-visible {
    border: 2px solid ${Color.CLOUD_BURST};
    border-radius: 5px;
  }
`;

export const StyledBreadcrumb = styled.div`
  display: flex;
  align-items: center;
  svg {
    font-size: 10px;
  }

  ${MediaQuery.M_AND_DOWN} {
    display: block;
  }
`;

export const StyledChevron = styled(FaChevronRight)`
  color: ${({ appearance }) =>
    appearance === BreadcrumbAppearance.MINIMAL && Color.WHITE};
`;
